export enum NavigationPath {
	new = 'new',
	inReview = 'review',
	paid = 'paid',
	inProgress = 'inProgress',
	cancelled = 'cancelled',
	shipped = 'shipped',
	invoiced = 'invoiced',
	all = 'all',
}
